import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "children", "text", "icon"];
import React, { useRef } from 'react';
import mergeCallbacks from 'utils/ui/mergeCallbacks';
import * as MenuListUI from 'components/MenuList';
import { useNavMenuContext } from './NavMenu';
function NavMenuItem(_ref) {
  var as = _ref.as,
    children = _ref.children,
    text = _ref.text,
    icon = _ref.icon,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var itemRef = useRef(null);
  var _useNavMenuContext = useNavMenuContext(),
    itemList = _useNavMenuContext.itemList;
  var clearHighlightedItem = itemList.clearHighlightedItem;
  var childrenAsText = typeof children === 'string' ? children : '';
  var _itemList$useItem = itemList.useItem({
      ref: itemRef,
      text: text || childrenAsText,
      value: text || childrenAsText
    }),
    select = _itemList$useItem.select,
    highlight = _itemList$useItem.highlight,
    useHighlighted = _itemList$useItem.useHighlighted;
  if (typeof children !== 'string' && !text) {
    // eslint-disable-next-line no-console
    console.warn('NavMenuItem: The type of the children prop is not "string". Please provide a string-only label to the menu item via the "text" prop.', children);
  }
  var forwardedAs = as || 'button';
  return /*#__PURE__*/React.createElement(MenuListUI.Item, null, /*#__PURE__*/React.createElement(MenuListUI.Link, _extends({}, otherProps, {
    ref: itemRef,
    forwardedAs: forwardedAs,
    isHighlighted: useHighlighted(),
    onClick: mergeCallbacks(select, otherProps.onClick),
    onFocus: mergeCallbacks(highlight, otherProps.onFocus),
    onMouseEnter: mergeCallbacks(highlight, otherProps.onMouseEnter),
    onMouseLeave: mergeCallbacks(clearHighlightedItem, otherProps.onMouseLeave)
  }), icon && /*#__PURE__*/React.createElement(MenuListUI.ItemIcon, {
    name: icon
  }), children));
}
export default NavMenuItem;